(function () {
    "use strict";

    class ProductCustomComponent extends HTMLElement {
      constructor() {
        super();
      }

      static get observedAttributes() {
        return ["product"];
      }

      get product() {
        return this._product;
      }

      set product(value) {
        this._product = value;
        this.render();
      }

      connectedCallback() {
        if (this._product) {
          this.render();
        }
      }

      render() {
        this.innerHTML = `<span class="junip-product-summary" data-product-id="${this._product.productId}"></span>`;
      }
    }

    customElements.define("rcc-custom-component-review", ProductCustomComponent);
  })();